module.exports = __webpack_public_path__ + "img/1-forOA.51f10e38.gif";